import React from 'react';

// Guêpe en emoji natif (🐝) — comme sur la page de maintenance, plus simple
// et plus fiable visuellement qu'un SVG dessiné à la main.
export default function Wasp({ className = '', title }) {
  return (
    <span className={`wasp-emoji ${className}`} aria-hidden="true" title={title}>🐝</span>
  );
}
